<template>
  <div
    class="flex-center fixed-0  bg-[#151A1F]  bg-maintain"
  >
  <div class="text-white text-2xl font-bold absolute   left-1/2 -translate-x-1/2 bottom-40 ">
    {{ errorCode }}
  </div>
</div>
</template>
<script setup lang="ts">
import { useRouter } from 'vue-router';
const router = useRouter();
const errorCode = ref('');
onMounted(() => {
const route = router.currentRoute.value;
const errorParam = route.query.error as string;
if (errorParam) {
  errorCode.value = errorParam;
}
}); 
</script>
<style lang="scss">
.bg-maintain{ 
  background-image: var(--bg_maintain);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
}
</style>
